import { Authority } from '../request'

const { get, post } = Authority
// 桥梁档案新增
export const bridgeAdd = params => post('/road/bridge-info/v1/add', params)

//桥梁档案删除
export const bridgeDelete = params => post('/road/bridge-info/v1/delete', params)

//桥梁档案更新
export const bridgeUpdate = params => post('/road/bridge-info/v1/update', params)

// 桥梁档案列表
export const getBridgeList = params => get('/road/bridge-info/v1/queryList', { params })

//桥梁档案列表下拉
export const getBridgeqQerySelectList = params => get('/road/bridge-info/v1/querySelectList', { params })
//桥梁档案详情
export const getBridge = params => get('/road/bridge-info/v1/queryOneById', { params })

